import { FormDataGroup } from 'src/types';

export const leadsVOPartialData = (isConfigure?: boolean, isDealer?: boolean): Partial<FormDataGroup> => ({
	headers: { FORM_OBJECTIVE: 'Más Información' },
	fields: {
		formFields: {},
		formularioFlag: 'masInformacion',
		formName: isConfigure ? 'lead-vo-configure' : isDealer ? 'lead-vo-dealer' : 'lead-vo',
		formType: 'contact',
		pageCategory: 'Más Información',
	},
});
